import { toast } from 'react-toastify';
import ApiBase from "./base";
import i18n from "../translations";
import { jsonToQueryString } from '../shared/utils';

export const _ATTEMP_URL = "quiz/attempt";

export async function getAttempList(params) {
    const response = await ApiBase.get(`${_ATTEMP_URL}?${jsonToQueryString(params)}`);

    return response;
}

export async function getAttempDetail(id) {
    const response = await ApiBase.get(`${_ATTEMP_URL}/${id}`);

    return response;
}